import React, { useState } from "react";
import { Box, Divider, Typography } from '@mui/material';
import FormularioVision from "../pages/Vision/FormularioVision";
import FormularioinfoVision from "../pages/Vision/FormularioinfoVision";
import ListaVision from "../pages/Vision/ListaVision";
import ListaInfoVision from "../pages/Vision/ListaInfoVision";
import VisionPages from "../pages/Vision/VisionPages";

const DashboardVisionWeb = () =>{
    const [visionSeleccionado, setVisionSeleccionado] = useState(null);
    const [infoVisionSeleccionado, setInfoVisionSeleccionado] = useState(null);
    
    // Función para manejar la edición de la visio y mision
    const handleEditarVision = (vision) => {
        setVisionSeleccionado(vision);
        console.log('Estoy en DashboardVision ' + vision);
    };

    // Función para manejar la edición del infovision
    const handleEditarInfoVision = (infovision) => {
        setInfoVisionSeleccionado(infovision);
        console.log('Estoy en DashboardVision ' + infovision);
    };

    return(
        <Box sx={{
            gap: '20px',
            margin: '10px 5px',
            textAlign: 'center',
            '@media (max-width: 600px)': {  // En móviles
                flexDirection: 'column', // Asegurarse que esté en columna
                width: '95%',
                gap: '20px',
                margin: '1% 5%',
            },
        }}>
            <Typography 
                variant='h5' 
                sx={{ 
                    width: 'auto',
                    alignItems: 'center',
                    textAlign: 'center',
                    '@media (max-width: 600px)': {  // Ajustes para móviles
                        fontSize: '1.25rem',  // Tamaño más pequeño para la tipografía
                        margin: '1% 5%',
                    },
                }}
            >
                Sección Nuestra visión
            </Typography>

            <Divider 
                sx={{
                    backgroundColor: '#8E0505',
                    width: '100%', // El ancho se ajusta a todo el espacio disponible
                    height: '0%',  // Puede ajustar el grosor aquí, aunque este valor es 0
                    margin: '1% 0%',
                    borderWidth: '0.1px',
                }} 
            />
            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', // En pantallas pequeñas, columna, en otras también columna
                gap: '20px',
                margin: '3% 0%',
            }}>

                {/* Agregar la vision y mision */}
                <FormularioVision visionSeleccionado={visionSeleccionado}/>

                {/* contenido de vision y mision */}
                <ListaVision onEditar={handleEditarVision}/>
                
            </Box>


            <Typography 
                variant='h5' 
                sx={{ 
                    width: 'auto',
                    alignItems: 'center',
                    textAlign: 'center',
                    '@media (max-width: 600px)': {  // Ajustes para móviles
                        fontSize: '1.25rem',  // Tamaño más pequeño para la tipografía
                        margin: '1% 5%',
                    },
                }}
            >
                Sección de la información de Nuestra visión
            </Typography>

            <Divider 
                sx={{
                    backgroundColor: '#8E0505',
                    width: '100%', // El ancho se ajusta a todo el espacio disponible
                    height: '0%',  // Puede ajustar el grosor aquí, aunque este valor es 0
                    margin: '1% 0%',
                    borderWidth: '0.1px',
                }} 
            />

            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', // En pantallas pequeñas, columna, en otras también columna
                gap: '20px',
                margin: '3% 0%',
            }}>

                {/*Formulario para agregar el contenido a la página web */}
                <FormularioinfoVision infoVisionSeleccionado={infoVisionSeleccionado} />
                
                {/*Lista de la informació que se muestra en la pagina de handleEditarInfoBlog*/}
                <ListaInfoVision onEditar={handleEditarInfoVision} />


            </Box>
            
            <VisionPages/>

        </Box>
    );
}

export default DashboardVisionWeb;